import i18n from '@/i18n.js';
import { clearNumber } from '@/modules/_global/filters';

const templateEmail = /.+@.+\..+/;
const templateEmoji = /\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/g;
const specialCharsRegx = /[!@#$%^&*()_+\-=\[\]{};'№:"\\|,.<>\/?]+/;
const alfaRegx = /^[\p{L}\p{M}]+$/u;
const alfanumericRegx = /^[\p{L}\p{M}\p{N}]+$/u;
const alfanumericDashRegx = /^[\p{L}\p{M}\p{N}-]+$/u;

export const alpha = v =>
  !v || alfaRegx.test(v) || i18n.t('MESSAGE.ONLY_LETTERS_AND_NUMBERS');
export const alphanumeric = v =>
  !v || alfanumericRegx.test(v) || i18n.t('MESSAGE.ONLY_LETTERS_AND_NUMBERS');
export const alphanumericDash = v =>
  !v ||
  alfanumericDashRegx.test(v) ||
  i18n.t('MESSAGE.ONLY_LETTERS_NUMBERS_DASHES');
export const notEmoji = v =>
  !v || !v.match(templateEmoji) || i18n.t('MESSAGE.THIS_FIELD_MUST_BE_VALID');
export const isEmail = v =>
  !v || templateEmail.test(v) || i18n.t('MESSAGE.THIS_FIELD_MUST_BE_VALID');
export const isInteger = v =>
  (!isNaN(v) && Number(v) % 1 === 0) || i18n.t('MESSAGE.INVALID_INTEGER');
export const isFloat = v =>
  (!isNaN(v) && Number(v) % 1 !== 0) || i18n.t('MESSAGE.INVALID_FLOAT');
export const isNumeric = n =>
  (!isNaN(parseFloat(n)) && isFinite(n)) || i18n.t('MESSAGE.INVALID_NUMERIC');
export const maxNumeric = max => v =>
  v <= max || i18n.t('MESSAGE.INVALID_MAX_NUMERIC', { max });
export const minNumeric = min => v =>
  v >= min || i18n.t('MESSAGE.INVALID_MIN_NUMERIC', { min });
export const maxLengthNumber = count => v =>
  !v ||
  Math.floor(v).toString().length <= count ||
  i18n.t('MESSAGE.INVALID_LENGTH');
export const lengthNumber = count => v =>
  !v ||
  Math.floor(v).toString().length == count ||
  i18n.t('MESSAGE.INVALID_LENGTH');
export const maxLengthArray = count => v =>
  !v || v.length <= count || i18n.t('MESSAGE.INVALID_LENGTH_ARRAY', { count });
export const maxLengthUploadArray = count => v =>
  !v || v.length <= count || i18n.t('MESSAGE.INVALID_LENGTH_UPLOAD_ARRAY');
export const maxLengthMaskedPhone = count => v =>
  !v ||
  v.replace(/[^0-9]/gi, '').length <= count ||
  i18n.t('MESSAGE.INVALID_LENGTH');
export const notEmpty = v => !!v || i18n.t('MESSAGE.THIS_FIELD_IS_REQUIRED');
export const notEmptyWithNull = v =>
  v !== undefined || i18n.t('MESSAGE.THIS_FIELD_IS_REQUIRED');
export const notEmptyArray = v =>
  !!v.length || i18n.t('MESSAGE.THIS_FIELD_IS_REQUIRED');
export const notEmptyIf = condition => v =>
  (!!v && !!condition) || i18n.t('MESSAGE.THIS_FIELD_IS_REQUIRED');
export const maxLength = count => v =>
  !v || v.toString().length <= count || i18n.t('MESSAGE.INVALID_LENGTH');
export const minLength = count => v =>
  !v || v.toString().length >= count || i18n.t('MESSAGE.INVALID_LENGTH');
export const lengthCount = count => v =>
  !v ||
  v.toString().length === count ||
  i18n.t('MESSAGE.INVALID_LENGTH_COUNT', { count });
export const positiveNumber = v =>
  !v || !v.toString().includes('-') || i18n.t('MESSAGE.NOT_POSITIVE_NUMBER');
export const withoutSpecialCharacters = v =>
  !v || !specialCharsRegx.test(v) || i18n.t('MESSAGE.ONLY_LETTERS_AND_NUMBERS');
export const coordinates = v =>
  !v ||
  /^[-]?((([0-8]?[0-9])(\.(\d{1,16}))?)|(90(\.0+)?)),\s?[-]?((((1[0-7][0-9])|([0-9]?[0-9]))(\.(\d{1,16}))?)|180(\.0+)?)$/.test(
    v
  ) ||
  i18n.t('MESSAGE.THIS_FIELD_MUST_BE_VALID');
export const hexColor = v =>
  !v ||
  /#([a-f]|[A-F]|[0-9]){3}(([a-f]|[A-F]|[0-9]){3})?\b/.test(v) ||
  i18n.t('MESSAGE.THIS_FIELD_MUST_BE_VALID');
export const requiredTextLine = [notEmpty, maxLength(255), notEmoji];
export const requiredTextLine65 = [notEmpty, maxLength(65), notEmoji];
export const textLine65 = [maxLength(65), notEmoji];
export const username = [notEmpty, maxLength(255), notEmoji]; // add regexp
export const textLine = [maxLength(255), notEmoji];

export const requiredTextDescription = [notEmpty, maxLength(1500), notEmoji];
export const requiredTextDescription240 = [notEmpty, maxLength(240), notEmoji];
export const textDescription240 = [maxLength(240), notEmoji];
export const textDescription400 = [maxLength(400), notEmoji];
export const textDescription = [maxLength(1500), notEmoji];
export const textDescription80 = [maxLength(80), notEmoji];

export const requiredEmail = [notEmpty, isEmail, maxLength(255), notEmoji];
export const email = [isEmail, maxLength(255), notEmoji];
export const emails = [
  arr =>
    (Array.isArray(arr) &&
      arr.length &&
      !arr.findLast(
        v =>
          !(
            templateEmail.test(v) &&
            v.toString().length <= 255 &&
            !v.match(templateEmoji)
          )
      )) ||
    i18n.t('MESSAGE.THIS_FIELD_MUST_BE_VALID')
];

export const requiredSelectArray = [
  v => !!v.length || i18n.t('MESSAGE.THIS_FIELD_IS_REQUIRED')
];
export const requiredSelectNotArray = [
  v => !!v || i18n.t('MESSAGE.THIS_FIELD_IS_REQUIRED')
];

// !!!!!!!!very strange
export const numberLessThan4 = [
  v =>
    !v ||
    (v.length <= 4 && /\d+\.\d*|\.?\d+/.test(v)) ||
    i18n.t('MESSAGE.THIS_FIELD_MUST_BE_VALID'),
  notEmoji
];

export const maxPriceNumeric = max => v =>
  clearNumber(v) <= max || i18n.t('MESSAGE.INVALID_MAX_NUMERIC', { max });

export const minPriceNumeric = min => v =>
  clearNumber(v) >= min || i18n.t('MESSAGE.INVALID_MIN_NUMERIC', { min });

export const maxLengthPriceNumber = count => v =>
  !v ||
  Math.floor(clearNumber(v)).toString().length <= count ||
  i18n.t('MESSAGE.INVALID_LENGTH');

export const positivePriceNumber = v =>
  !v ||
  !clearNumber(v)
    .toString()
    .includes('-') ||
  i18n.t('MESSAGE.NOT_POSITIVE_NUMBER');
